import { render, staticRenderFns } from "./PaySlip.vue?vue&type=template&id=d17b7074&scoped=true"
import script from "./PaySlip.vue?vue&type=script&lang=js"
export * from "./PaySlip.vue?vue&type=script&lang=js"
import style0 from "./PaySlip.vue?vue&type=style&index=0&id=d17b7074&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d17b7074",
  null
  
)

export default component.exports